import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ message, type = 'info', onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const bgColors = {
    success: 'bg-green-600/95',
    error: 'bg-red-600/95',
    info: 'bg-blue-600/95'
  };

  const icons = {
    success: '✅',
    error: '🚫',
    info: 'ℹ️'
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none p-6">
        <div className={`pointer-events-auto flex items-center gap-4 px-8 py-5 rounded-2xl text-white shadow-2xl border border-white/20 animate-fade-in backdrop-blur-md ${bgColors[type]}`}>
            <span className="text-2xl">{icons[type]}</span>
            <p className="font-bold text-sm tracking-tight">{message}</p>
        </div>
    </div>
  );
};

export default Toast;
